import {Select} from 'antd';
import {AbstractSelectProps} from 'antd/es/select';
import React, {memo, RefForwardingComponent, useEffect} from 'react';
import {useAsync} from 'react-async-hook';
import {useSession} from '../../../contexts/Session';
import {WakandaService} from '../../../util/fetch-wakanda';
import {Currency, typedForwardRef} from '../../../util/render';
import {Transporteur} from '../../Orders/data';

const {Option} = Select;

export interface TransporterSelectProps extends AbstractSelectProps {
  value?: Transporteur;
  onChange?: (value: Transporteur | undefined) => void;
  clientId: string;
}

const TransporterSelect: RefForwardingComponent<
  Select<string>,
  TransporterSelectProps
> = (props, ref) => {
  const {clientId, ...selectProps} = props;
  const {value: transporter, onChange} = selectProps;
  const session = useSession();

  const transporters = useAsync(
    async (session: WakandaService, clientId: string) =>
      (clientId &&
        (await session.fetch<Transporteur[]>('Transporteurs', 'getTRP', {
          clientId,
        }))) ||
      [],
    [session, clientId],
    {setLoading: (state) => ({...state, result: []})},
  );

  useEffect(() => {
    if (!transporters.result || transporters.result.length === 0) {
      return;
    }

    const currentTransporterID = transporter?.ID;
    const defaultTransporter: Transporteur | undefined =
      transporters.result.length === 1
        ? transporters.result[0]
        : transporters.result.find(({defaut}) => defaut);

    if (
      defaultTransporter &&
      currentTransporterID !== transporters.currentParams?.[1]
    ) {
      // eslint-disable-next-line no-console
      /* console.warn(
        `should not happen, got ${defaultTransporter.ID} transporter despite ${currentTransporterID} !== ${transporters.currentParams?.[1]}`,
      ); */
    }

    if (
      (currentTransporterID &&
        !transporters.result.find(({ID}) => ID === currentTransporterID)) ||
      (!currentTransporterID && defaultTransporter)
    ) {
      onChange?.(defaultTransporter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transporters, /*transporter,*/ onChange]);

  return (
    <Select<string>
      ref={ref}
      {...selectProps}
      value={transporter?.ID}
      onChange={(transporterID) =>
        onChange?.(transporters.result?.find(({ID}) => ID === transporterID))
      }
      disabled={(transporters.result?.length ?? 0) < 2}
    >
      {transporters.result?.map(({ID, libelle/* , delai, prix */}) => (
        <Option value={ID} key={ID}>
          {libelle}
          {/* {delai || prix ? ' (' : null}
          {delai ? `livraison en ${delai} jour${delai > 1 ? 's' : ''}` : null}
          {delai && prix ? ', ' : null}
          {prix ? (
            <span>
              à partir de&nbsp;
              <Currency price={prix} />
            </span>
          ) : null}
          {delai || prix ? ')' : null} */}
        </Option>
      ))}
    </Select>
  );
};

export default memo(typedForwardRef(TransporterSelect));
